import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

const data = [
  {
    industry: 'Servicios logísticos',
    transporte: { min: '5%', avg: '20%', max: '50%' },
    distribución: { min: '5%', avg: '15%', max: '50%' },
    logístico: { min: '10%', avg: '25%', max: '50%' },
  },
  {
    industry: 'Automotriz',
    transporte: { min: '3%', avg: '8%', max: '21%' },
    distribución: { min: '3%', avg: '21%', max: '50%' },
    logístico: { min: '4%', avg: '12%', max: '50%' },
  },
  {
    industry: 'Manufactura',
    transporte: { min: '2%', avg: '5%', max: '10%' },
    distribución: { min: '5%', avg: '7%', max: '15%' },
    logístico: { min: '3%', avg: '10%', max: '20%' },
  },
  {
    industry: 'Alimentos',
    transporte: { min: '1%', avg: '6%', max: '15%' },
    distribución: { min: '1%', avg: '7%', max: '18%' },
    logístico: { min: '1%', avg: '10%', max: '25%' },
  },
  {
    industry: 'Construcción',
    transporte: { min: '1%', avg: '6%', max: '12%' },
    distribución: { min: '1%', avg: '7%', max: '15%' },
    logístico: { min: '3%', avg: '8%', max: '18%' },
  },
  {
    industry: 'Salud / Farmacéuticas',
    transporte: { min: '1%', avg: '5%', max: '12%' },
    distribución: { min: '1%', avg: '3%', max: '10%' },
    logístico: { min: '2%', avg: '9%', max: '20%' },
  },
  {
    industry: 'Retail',
    transporte: { min: '1%', avg: '4%', max: '12%' },
    distribución: { min: '1%', avg: '12%', max: '25%' },
    logístico: { min: '3%', avg: '7%', max: '20%' },
  },
];

const CostTable = () => {
  return (
    <TableContainer component={Paper} style={{ width: '100%', margin: '20px auto' }}>
      <Typography variant="h6" align="center" gutterBottom>
        Costo de transporte, costo de distribución y costo logístico total como % de las ventas totales (2023).
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" rowSpan={2} style={{ fontWeight: 'bold', backgroundColor: '#E0F2F1', borderRight: '1px solid #ddd' }}>
              Industrias
            </TableCell>
            <TableCell align="center" colSpan={3} style={{ fontWeight: 'bold', backgroundColor: '#E0F2F1', borderRight: '1px solid #ddd' }}>
              Costo de transporte como % de las ventas totales.
            </TableCell>
            <TableCell align="center" colSpan={3} style={{ fontWeight: 'bold', backgroundColor: '#E0F2F1', borderRight: '1px solid #ddd' }}>
              Costo de distribución como % de las ventas totales.
            </TableCell>
            <TableCell align="center" colSpan={3} style={{ fontWeight: 'bold', backgroundColor: '#E0F2F1' }}>
              Costo logístico total como % de las ventas totales.
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Mín.</TableCell>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Promedio</TableCell>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Máx.</TableCell>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Mín.</TableCell>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Promedio</TableCell>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Máx.</TableCell>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Mín.</TableCell>
            <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>Promedio</TableCell>
            <TableCell align="center">Máx.</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.industry}>
              <TableCell align="center" style={{ fontWeight: 'bold', borderRight: '1px solid #ddd' }}>{row.industry}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.transporte.min}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.transporte.avg}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.transporte.max}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.distribución.min}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.distribución.avg}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.distribución.max}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.logístico.min}</TableCell>
              <TableCell align="center" style={{ borderRight: '1px solid #ddd' }}>{row.logístico.avg}</TableCell>
              <TableCell align="center">{row.logístico.max}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CostTable;